/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderFxLauncherOptions, FxIdApplicationPublicDataBuilderFxLauncherOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderFxLauncherOptionsToJSON, } from './FxIdApplicationPublicDataBuilderFxLauncherOptions';
export function FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderFxLauncherOptions(json)) {
        return FxIdApplicationPublicDataBuilderFxLauncherOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderFxLauncherOptions(value)) {
        return FxIdApplicationPublicDataBuilderFxLauncherOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptions.js.map